<template>
  <v-app id="app">
    <router-view/>
    <!-- global staff on the top -->
    <Drawer/>
    <v-alert
      :value="$store.state.error.auth"
      type="error"
      transition="scale-transition"
    >
      授权错误：{{$store.state.error.auth}}
    </v-alert>
    <v-alert
      :value="$store.state.error.task"
      type="error"
      transition="scale-transition"
    >
      任务信息错误：{{$store.state.error.task}}
    </v-alert>
    <v-alert
      :value="$store.state.error.taskList"
      type="error"
      transition="scale-transition"
    >
      任务列表错误：{{$store.state.error.taskList}}
    </v-alert>
    <vue-progress-bar></vue-progress-bar>
  </v-app>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import Drawer from '@/components/Drawer'

export default {
  components: {
    Drawer
  },
  computed: {
    ...mapGetters([
      'isAuthenticated'
    ]),
    isProd () {
      return process.env.NODE_ENV === 'production'
    },
    pending () {
      let result = false
      const pending = this.$store.state.pending
      result = pending.auth || pending.task || pending.taskList
      return result
    },
    error () {
      let result = false
      const error = this.$store.state.error
      result = error.auth || error.task || error.taskList
      return result
    }
  },
  watch: {
    isAuthenticated (value) {
      if (value) {
        this.$router.push({ name: 'home' })
      } else {
        if (this.$route.name !== 'login') {
          this.$router.push({ name: 'login' })
        }
      }
    },
    pending (value) {
      if (value) {
        this.$Progress.start()
      } else {
        if (this.error) {
          this.$Progress.fail()
        } else {
          this.$Progress.finish()
        }
      }
    },
    error (err) {
      if (err && err.response && err.response.status) {
        if (err.response.status === 401) {
          const app = this
          setTimeout(() => {
            app.logout()
          }, 1000)
        }
      }
    }
  },
  methods: {
    ...mapActions([
      'logout'
    ])
  },
  mounted () {
    // this.$Progress.start()
  }
}
</script>

<style lang="scss">
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
}
a {
  color:white !important;
}
</style>

<style lang="scss" scoped>
@import '~@/stylesheets/color.scss';
@import '~@/stylesheets/layer.scss';

#nav {
  position: fixed;
  top: auto;
  left: 0;
  right: 0;
  bottom: 0;
  text-align: left;
  z-index: $layer-top;
  a {
    padding: .25rem;
    font-weight: bold;
    &.router-link-exact-active {
      color: $color_bleu_de_france;
    }
  }
}
</style>
